<template>
  <div class="admin-fields">
    <div class="panelheader border-3">
      <div class="title">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/admin/clients'}">Clients Admin</el-breadcrumb-item>        
          <el-breadcrumb-item :to="{ path: '/admin/clients/' + clientId}">Sites Admin</el-breadcrumb-item>
          <el-breadcrumb-item>{{pageName}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <div class="btn-wrapper">
        <el-button type="add" @click="onNewField">New Field</el-button>  
      </div>

    </div>

    <div class="fields">
        <h2>{{siteName}}</h2>

        <div v-if="newField">
          <newfield :fieldData="fieldData" :siteId="id" @close="onClose"></newfield>
        </div>
        <div v-else-if="editField">
          <editfield :fieldData="fieldData" @close="onClose"></editfield>
        </div>
        <div v-else>
          <fieldtable v-if='!reloading'
            :clientId="clientId" 
            :id="id"
            @editField="onEditField" 
            @deleteField="onDeleteField">
          </fieldtable>
        </div>
    </div>

  </div>
</template>

<script>
  import auth from '../../../auth'
  import requests from '../../../requests'
  import fieldtable from './FieldTable.vue'
  import newField from './NewField.vue'
  import editField from './EditField.vue'
  
  export default {
    name: 'admin-fields',
    data () {
      return {
        pageName: 'Fields Admin',
        fieldData: {
          field_name: '',
          field_no: '',
          type_id: '',
          light_status: 0,
          site_id: '',
          light_type_id: '',
          min_off_time: 0,
          logical_no:'',
          power_relay:'',
          delay: 10,
          interface_id: '',
          lights: [],
        },
        siteName: '',
        clientId: 0,
        id: 0,
        fields:[],
        newField: false,
        editField: false,
        userIsSuperAdmin: false,
        reloading: false
      }
    },
    beforeMount(){
      var profile = JSON.parse(auth.getProfile());
      this.userIsSuperAdmin = (profile.role === 3);
      
      // this.userIsSuperAdmin = true;

      this.id = this.$route.params.id;
      this.clientId = this.$route.params.clientId;

    },
    updated() {
      this.reloading = false;
    },
    methods: {
      onNewField() {
        this.editField = false;
        this.newField = true;
      },
      onEditField(fieldData) {
        this.fieldData = fieldData;

        this.newField = false;
        this.editField = true;
      },
      onDeleteField(id) {
        var context = this;
        requests.deleteField(this, id, function(result) {
          if(result.action !== 'success') {
            context.$message({
              type: 'error',
              message: 'Couldn\'t delete field: ' + result.msg.body.msg,
            })
          }
          context.reloading = true;
        });
      },
      onClose() {
        this.newField = false;
        this.editField = false;
      },
    },
    components: {
      'fieldtable': fieldtable,
      'newfield': newField,
      'editfield': editField
    }
  }
</script>

<style>
  .admin-fields .fields {
    display: block;
    padding: 15pt;
    background-color: white;
  }

  .admin-fields .fieldtable .el-table__row {
    cursor: pointer;
  }

</style>



// WEBPACK FOOTER //
// Fields.vue?11e54832